import {alphas, greys, greysDark} from '../../styles/colorStyles';
import {colorPrimitive} from '../../styles/primitives/colorPrimitive';
import {lightTypographySemanticStyles} from './typographySemanticStyles';

export interface TextSemanticStyles {
  default: string;
  composer: string;
  placeholder: string;
  inverted: string;
  invertedSecondary: string;
  highlight: string;
  disabled: string;
  secondary: string;
}

export const lightTextSemanticStyles = {
  default: lightTypographySemanticStyles.shades.primary,
  composer: greys.black,
  placeholder: greys.shade60,
  inverted: greys.white,
  invertedSecondary: alphas.white50,
  highlight: greys.shade90,
  disabled: colorPrimitive.gray[400],
  secondary: '#303336', // TODO PB-61869: This should be moved somewhere.
} as const satisfies TextSemanticStyles;

export const darkTextSemanticStyles = {
  default: greysDark.shade80,
  composer: greysDark.black,
  placeholder: greysDark.shade70,
  inverted: greysDark.black,
  invertedSecondary: alphas.white50,
  highlight: greys.shade90,
  disabled: colorPrimitive.gray[400], // TODO PB-61869: This color value should probably be different.
  secondary: '#303336', // TODO PB-61869: This color value should probably be different.
} as const satisfies TextSemanticStyles;
